import { createApiRef } from '@backstage/core-plugin-api';
import { LoggingSearchRequest, LoggingSearchResponse } from './type';

export interface LoggingApi {
  searchLogs(
    indexName: string,
    searchRequest: LoggingSearchRequest,
  ): Promise<LoggingSearchResponse>;

  getIndices(): Promise<string[]>;
  invalidateCache(pattern?: string): void;
  getCacheStats(): { size: number; keys: string[] };
}

export const loggingApiRef = createApiRef<LoggingApi>({
  id: 'plugin.logging.service',
});
